import BaseNotificationHandler from './baseHandler.js';

/**
 * Guardianship Notification Handler
 * Handles guardianship invitation and response notifications
 */
class GuardianshipHandler extends BaseNotificationHandler {
    getIcon(notification, parsedData) {
        return "🐾";
    }

    getMainText(notification, parsedData) {
        const senderName = this.getSenderInfo(notification, parsedData) || 'Someone';

        if (notification.type === 'guardianship_response') {
            const status = parsedData.status || (notification.data?.status);
            const statusText = status === 'accepted' ? 'accepted' : 'refused';
            const petName = parsedData.pet_name || 'your pet';
            return `${senderName} has ${statusText} your guardianship invitation for ${petName}`;
        }

        const petName = parsedData.pet_name || 'their pet';
        return `${senderName} invited you to become a guardian for ${petName}`;
    }

    handleClick(notification, parsedData, navigate, onClose) {
        if (notification.type === 'guardianship_invitation') {
            const requestId = parsedData.request_id || notification.target_id;
            if (requestId) {
                sessionStorage.setItem('highlightGuardianshipRequestId', requestId.toString());
            }
            navigate('/dashboard/pets');
            if (onClose) onClose();
            return;
        }

        const petId = parsedData.pet_id;
        if (petId) {
            navigate(`/pets/${petId}/view`);
            if (onClose) onClose();
        } else {
            super.handleClick(notification, parsedData, navigate, onClose);
        }
    }

    /**
     * Guardianship invitations have action buttons (Accept, Reject)
     */
    hasActionButtons(notification, parsedData) {
        return notification.type === 'guardianship_invitation';
    }
}

export default GuardianshipHandler;
